import React, { useState } from 'react';

import Footer from '../components/Footer';
import Navbar from '../components/Navbar';



import image01 from '../assets/CardsImages/card-4-img/img-9.jpg'
import image02 from '../assets/CardsImages/card-4-img/img-11.jpg'
import image03 from '../assets/CardsImages/card-4-img/img-13.jpg'
import image04 from '../assets/CardsImages/card-4-img/img-35.jpg'
import image05 from '../assets/CardsImages/card-4-img/img-43.jpg'
import image06 from '../assets/CardsImages/card-4-img/img-47.jpg'
import image07 from '../assets/CardsImages/card-4-img/img-48.jpg'
import image08 from '../assets/CardsImages/card-4-img/img-49.jpg'
import image09 from '../assets/CardsImages/card-4-img/img-50.jpg'
import image10 from '../assets/CardsImages/card-4-img/img-51.jpg'
import image11 from '../assets/CardsImages/card-4-img/img-52.jpg'
import image12 from '../assets/CardsImages/card-4-img/img-53.jpg'
import image13 from '../assets/CardsImages/card-4-img/img-54.jpg'
import image14 from '../assets/CardsImages/card-4-img/img-55.jpg'
import image15 from '../assets/CardsImages/card-4-img/img-56.jpg'
import image16 from '../assets/CardsImages/card-4-img/img-57.jpg'



const Card04 = () => {



    const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image

    const images = [
        image01,
        image02,
        image03,
        image04,
        image05,
        image06,
        image07,
        image08,
        image09,
        image10,
        image11,
        image12,
        image13,
        image14,
        image15,
        image16


        // Add the rest of the images here...
    ];

    const handleImageClick = (image) => {
        setSelectedImage(image); // Set the selected image
    };

    const handleClose = () => {
        setSelectedImage(null); // Clear the selected image
    };


    return (

        <div>
            {/* <Navbar /> */}
            <div className="container mx-auto px-6 py-12 mt-8">
                <h1 className="text-3xl font-bold text-center text-purple-950 mb-8">Maintenance of Distillation Column</h1>
                <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">
                    <h2 className="text-2xl font-semibold mb-4">Maintenance of Distillation Column</h2>
                    <p className="mb-4">
                        All types of maintenance of distillation column expertise. Maintenance of distillation columns requires a range of expertise and skills to ensure the efficient and safe operation of these critical components in chemical and petrochemical processes. Here are various types of maintenance expertise required for distillation columns:
                    </p>
                    {/* <p className="mb-4">
            Distillation column supervision and inspection jobs are crucial to maintain the reliability, safety, and
            performance of these critical components in various industrial processes.
          </p> */}
                </div>

                <div className="container mx-auto px-4 py-8 my-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">1. Routine Maintenance</h2>
                            <p className="text-gray-700">
                                Routine maintenance tasks include inspections, lubrication, cleaning, and tightening of bolts and fasteners to ensure the ongoing performance of the column.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">2. Preventive Maintenance</h2>
                            <p className="text-gray-700">
                                Develop and implement a preventive maintenance program to address potential issues before they become critical. This may involve regular equipment checks, scheduled component replacements, and calibration of instruments.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">3. Predictive Maintenance</h2>
                            <p className="text-gray-700">
                                Utilize predictive maintenance techniques, such as vibration analysis, thermography, and oil analysis, to predict equipment failures and address issues proactively.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">4. Corrosion Management</h2>
                            <p className="text-gray-700">
                                Understand corrosion mechanisms and apply appropriate materials and coatings to protect the column's internals and external surfaces from corrosion. Implement a corrosion monitoring program.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">5. Instrumentation and Control</h2>
                            <p className="text-gray-700">
                                Expertise in instrumentation and control systems is essential for ensuring precise control of the distillation process. Calibrate and maintain instruments, control valves, and safety interlocks.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">6. Mechanical Integrity</h2>
                            <p className="text-gray-700">
                                Assess the mechanical integrity of the distillation column and its internals to ensure they can withstand operating conditions and maintain their structural integrity.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">7. Safety and Regulatory Compliance</h2>
                            <p className="text-gray-700">
                                Maintain knowledge of safety regulations, industry standards, and environmental regulations to ensure compliance in maintenance activities.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">8. Training and Knowledge Transfer</h2>
                            <p className="text-gray-700">
                                Provide training and guidance to plant personnel, ensuring that they understand and follow maintenance best practices.


                            </p>
                        </div>
                    </div>
                </div>



                <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">

                    <p className="mb-4">
                        Successful maintenance of distillation columns requires a multidisciplinary approach, involving expertise in mechanical engineering, materials science, instrumentation and control, safety, and project management. It is also crucial to stay updated with the latest industry advancements and technologies to enhance the reliability and performance of distillation columns while ensuring safety and regulatory compliance.
                    </p>
                </div>

                {/* All Work Section */}
                <div className="my-12 text-center">
                    <h2 className="text-2xl font-semibold text-purple-900 mb-4">All Work</h2>
                    <p className="text-lg text-gray-700 mb-4">We provide high standard work for your Company solutions</p>
                </div>

                {/* Images Section */}
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                            onClick={() => handleImageClick(image)} // Set the image on click
                        >
                            <img
                                src={image}
                                alt={`Gallery Image ${index + 1}`}
                                className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                            />
                        </div>
                    ))}
                </div>


                {/* Modal to show selected image */}
                {selectedImage && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
                        <div className="relative">
                            <img
                                src={selectedImage}
                                alt="Selected"
                                className="max-w-full max-h-screen rounded-lg"
                            />
                            <button
                                onClick={handleClose}
                                className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
                            >
                                ✖
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* <Footer /> */}
        </div>
    );
};

export default Card04;
